import BrandPageSectionOne from "./BrandPageSectionOne";
import BrandPageSectionTwo from "./BrandsPageSectionTwo";
import BrandsPageHero from "./BrandsPageHero";
import BrandsPageIntro from "./BrandsPageIntro";
import Layout from "./Layout";
import PageContent from "./PageContent";
import React from "react";

function BrandsPage({ pageData, navItems, globalData, brands }) {
  return (
    <Layout navItems={navItems} globalData={globalData}>
      <PageContent>
        <BrandsPageHero
          heading={pageData.heading}
          imageDesktop={pageData.heroImageDesktop}
          imageMobile={pageData.heroImageMobile}
          brands={brands}
          quote={pageData.heroQuote}
          quoteSource={pageData.heroQuoteSource}
          quoteImage={pageData.heroQuoteImage}
        />
        <BrandsPageIntro
          heading={pageData.introHeading}
          text={pageData.introText}
        />
        <BrandPageSectionOne
          heading={pageData.section1Heading}
          text={pageData.section1Text}
          quote={pageData.section1Quote}
          quoteSource={pageData.section1QuoteSource}
          quoteImage={pageData.section1QuoteImage}
        />
        <BrandPageSectionTwo
          imageDesktop={pageData.section2ImageDesktop}
          imageMobile={pageData.section2ImageMobile}
          youtubeId={pageData.section2YoutubeId}
          heading={pageData.section2Heading}
          text={pageData.section2Text}
        />
      </PageContent>
    </Layout>
  );
}

export default BrandsPage;
